"use strict";

var _interopRequireDefault = require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/john/Desktop/Projects/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _OutputFactory = _interopRequireDefault(require("../OutputFactory"));
var _excluded = ["_io", "read"];
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/Table/CollapseView.js";
function CollapseView(index, object, excludeFields, fields, actions, onClickItem, fieldImage) {
  var _this = this;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 17
    }
  }, fieldImage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3",
    style: {
      width: "100px",
      height: "100px"
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 29
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "w-100 h-100",
    style: {
      objectFit: 'cover'
    },
    src: object[fieldImage],
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 33
    }
  })), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled ms-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 21
    }
  }, Object.keys(fields).map(function (field) {
    var _fields$field = fields[field],
      _io = _fields$field._io,
      read = _fields$field.read,
      options = (0, _objectWithoutProperties2["default"])(_fields$field, _excluded);
    if (options._type === "Image") return null;
    if (options.detail !== true && excludeFields.includes(field) || _io === false || read === false) return null;
    var output = /*#__PURE__*/_react["default"].createElement(_OutputFactory["default"], Object.assign({
      field: field,
      object: object
    }, options, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30,
        columnNumber: 37
      }
    }));
    if (!output) return null;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: field,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 37
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "ms-2 fw-light",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 41
      }
    }, options.label || field, ": "), /*#__PURE__*/_react["default"].createElement("span", {
      className: "fs-sm text-nowrap",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39,
        columnNumber: 41
      }
    }, output));
  }))), actions.length > 0 ? actions.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: action.className ? action.className : "btn btn-primary btn-sm ms-2",
      onClick: function onClick() {
        return action.onClick(index);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 29
      }
    }, action.label);
  }) : /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-primary btn-sm",
    onClick: function onClick() {
      return onClickItem(index);
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 29
    }
  }, "EDIT"));
}
var _default = exports["default"] = CollapseView;